import { arrayToDistinct } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { AutoComplete, Form, InputNumber } from "antd";
import React, { useMemo } from "react";
import FormItemProps from "../../../types/FormItemProps";

export default (props: FormItemProps) => {
  const t = useTranslation();

  const options = useMemo(() => {
    if (!props.items) return [];
    const units = props.items
      .filter((item) => item.stockUnit)
      .map((item) => ({ value: item.stockUnit }));

    return arrayToDistinct(units, (obj) => obj.value);
  }, [props.items]);

  return (
    <>
      <Form.Item
        label={t("maintenance:items.create.form.stock.label")}
        name="stock"
        initialValue={props.editItem?.stock}
      >
        <InputNumber style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item
        label={t("maintenance:items.create.form.stockUnit.label")}
        name="stockUnit"
        initialValue={props.editItem?.stockUnit}
      >
        <AutoComplete options={options} filterOption />
      </Form.Item>
      <Form.Item
        label={t("maintenance:items.create.form.stockAlarmAt.label")}
        name="stockAlarmAt"
        initialValue={props.editItem?.stockAlarmAt}
      >
        <InputNumber style={{ width: "100%" }} />
      </Form.Item>
    </>
  );
};
